import { responseHandler } from './apiHelper';
import { fetchOptionalLegacyProps } from '../config';

const buildOauthUrl = (redirectUrl) => {
  const props = fetchOptionalLegacyProps();
  const host = props?.oauth_api_host || '';

  return `${host}/api/v1/oauth/?redirect=${encodeURIComponent(redirectUrl)}`;
};

// eslint-disable-next-line import/prefer-default-export
export const fetchOauthProviders = (redirectUrl) => fetch(buildOauthUrl(redirectUrl))
  .then(responseHandler);

// eslint-disable-next-line import/prefer-default-export
export const buildOauthProviderUrl = (provider, redirectUrl) => {
  const props = fetchOptionalLegacyProps();
  const host = props?.oauth_api_host || '';

  return `${host}/api/v1/oauth/provider/${provider}?redirect=${encodeURIComponent(redirectUrl)}`;
};
